import React from 'react';
import { media, mediaSection } from '../../content/siteContent';
import SectionHead from './SectionHead';
import { ArrowLinkIcon } from './Icons';

export default function Media() {
  return (
    <section id="midia" className="section-wrap section-wrap--band-soft">
      <SectionHead tag={mediaSection.tag} title={mediaSection.title} subtitle={mediaSection.subtitle} />

      <div className="media-list">
        {media.map((item) => (
          <a
            key={item.link}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="media-card"
            aria-label={`${item.ariaPrefix}: ${item.title} (abre em nova aba)`}
          >
            <div className="media-info">
              <span className="media-tag">{item.tag}</span>
              <h3 className="media-title">{item.title}</h3>
            </div>
            <span className="media-action">
              <span>Ver conteúdo</span>
              <ArrowLinkIcon size={18} strokeWidth={2.2} />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}
